module.exports = __webpack_public_path__ + "momunes.jpg?209677f2ee43ce3f295811649337bccc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/momunes.jpg
// module id = 136
// module chunks = 0